import PluginRange from './PluginRange.vue'

export default PluginRange